// Enlaces directos: convierte entre las pantallas de la app y su dirección (/eventos, /formas/1er-dan…).
const VIEW_PATHS={
  eventos: 'eventos',
  entrenamiento: 'entrenamiento',
  perfil: 'perfil',
  'admin-eventos': 'admin/eventos',
  usuarios: 'admin/usuarios',
  metricas: 'admin/metricas',
  comentarios: 'admin/comentarios',
};

const TAB_PATHS={
  basicos: 'basicos',
  secuencias: 'secuencias',
  formas: 'formas',
  defensa_personal: 'defensa-personal',
};

// Atajos más naturales para compartir: /formas/primer-dan lleva a /formas/1er-dan.
const GROUP_ALIASES={
  'primer-dan': '1er-dan',
  'segundo-dan': '2o-dan',
  'tercer-dan': '3er-dan',
  'cuarto-dan': '4o-dan',
};

export const ADMIN_VIEWS=['admin-eventos','usuarios','metricas','comentarios'];

export const slugify=(text)=> String(text)
  .normalize('NFD').replace(/[̀-ͯ]/g,'')
  .toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-+|-+$/g,'');

export function buildPath({view,tab,group,eventId}) {
  if (view==='category') return `/${TAB_PATHS[tab] || ''}${group ? `/${group}` : ''}`;
  if (view==='eventos') return eventId ? `/eventos/${eventId}` : '/eventos';
  return VIEW_PATHS[view] ? `/${VIEW_PATHS[view]}` : '/';
}

// Devuelve la pantalla que corresponde a una dirección; cualquier dirección desconocida es el inicio.
export function parsePath(pathname) {
  const parts=pathname.split('/').filter(Boolean).map(decodeURIComponent);
  const [first,second]=parts;

  if (!first) return {view: 'home'};
  if (first==='eventos') return {view: 'eventos',eventId: second || null};

  const tab=Object.keys(TAB_PATHS).find(key=> TAB_PATHS[key]===first);
  if (tab) return {view: 'category',tab,group: second ? (GROUP_ALIASES[second] || second) : null};

  const joined=parts.join('/');
  const view=Object.keys(VIEW_PATHS).find(key=> VIEW_PATHS[key]===joined);
  return view ? {view} : {view: 'home'};
}
